import React from 'react';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import { DatePicker } from '@material-ui/pickers';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';

// TODO: use this one on the several places we use a custom dialog
class DateOfBirthDialog extends React.Component {
  constructor(props) {
    super(props);
    let minDate = new Date();
    minDate.setFullYear(1995);

    this.state = {
      value: null,
      minDate: minDate,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      this.setState({
        value: null,
      });
    }
  }

  render() {
    const {
      t,
      isOpen,
      onClose,
      onConfirm,
    } = this.props;
    const {
      value,
    } = this.state;

    return (
      <Dialog
        open={isOpen}
        onClose={onClose}
        aria-labelledby="date-of-birth-dialog-title"
        className="date-of-birth-dialog"
      >
        <DialogTitle id="date-of-birth-dialog-title">
          {t('Date of birth')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {t('Please enter your date of birth below.')}
          </DialogContentText>
          <div style={{ textAlign: 'center' }}>
            <DatePicker
              variant="inline"
              openTo="year"
              minDate={ this.state.minDate }
              maxDate={ new Date() }
              views={['year', 'month', 'date']}
              label={t('Date of Birth')}
              value={value}
              initialFocusedDate={moment().subtract(14, 'years')}
              onChange={value => this.setState({ value: value.format('YYYY-MM-DD') })}
              format={dateFormat}
              autoComplete="off"
              disableFuture
              autoOk
              PopoverProps={{
                anchorOrigin: { horizontal: 'center', vertical: 'center' },
                transformOrigin: { horizontal: 'center', vertical: 'center' },
              }}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={onConfirm.bind(this, value)}
            color="primary"
            className="date-of-birth-dialog-confirm-button"
          >
            {t('Ok')}
          </Button>
          <Button
            onClick={onClose}
            className="date-of-birth-dialog-cancel-button"
          >
            {t('Cancel')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withTranslation()(DateOfBirthDialog);
